/*
<summary>
   This functional component is all about rendering the Step 1/Step 2 progress stepper for the Tool Management form.
   Developer: Aashish Singh, Created Date: 20-Aug-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { FormattedMessage } from 'react-intl';
import { RoundTabIcon } from '../../../../shared-components/svgs/svgs';

interface IProps {
  step: 1 | 2;
  hasStepTwo?: boolean;
}

const ToolStepper = ({ step, hasStepTwo = true }: IProps) => {
  return (
    <div className="wizard overflow-hidden">
      <div className="wizard-inner position-relative mb-0 text-center">
        {hasStepTwo && (
          <div className="connecting-line position-absolute end-0 z-0 mx-auto my-0"></div>
        )}
        <ul
          className={`nav nav-tabs position-relative my-0 ${
            hasStepTwo ? 'justify-content-between w-75 mx-auto' : 'justify-content-center'
          }`}
          role="tablist"
        >
          <li
            role="presentation"
            className="active"
          >
            <a
              className="d-block position-relative rounded-circle bg-transparent p-0"
              data-toggle="tab"
              aria-controls="step1"
              role="tab"
              aria-expanded={step === 1}
            >
              <span className="round-tab d-inline-block rounded-circle text-center fw-medium position-relative z-3 text-white">
                {step > 1 ? <RoundTabIcon /> : '1'}
              </span>
              <i className="fst-normal fw-normal text-nowrap d-block"><FormattedMessage id="step1" /></i>
            </a>
          </li>
          {hasStepTwo && (
            <li
              role="presentation"
              className={step === 2 ? 'active' : 'disabled'}
            >
              <a
                className="d-block position-relative rounded-circle bg-transparent p-0"
                data-toggle="tab"
                aria-controls="step2"
                role="tab"
                aria-expanded={step === 2}
              >
                <span
                  className={`round-tab d-inline-block rounded-circle text-center fw-medium position-relative z-3 ${
                    step === 2 ? 'text-white' : ''
                  }`}
                >
                  2
                </span>
                <i className="fst-normal fw-normal text-nowrap d-block"><FormattedMessage id="step2" /></i>
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ToolStepper;
